<div>
  <div class="center">
    {{ screenName }}
  </div>

  <div class="left">
    <ppl-top-navigation-button
      [pplPopover]="popoverAppSwitcher"
      pplPopoverAlignEnd>
      <ppl-icon
        svgIcon="app-switcher"
        width="18px"
        height="18px"></ppl-icon>
    </ppl-top-navigation-button>
    <ng-template
      #popoverAppSwitcher
      let-position="position">
      <ppl-popover-window
        [position]="position"
        style="margin-left: 5px">
        <ppl-top-navigation-app-switcher></ppl-top-navigation-app-switcher>
      </ppl-popover-window>
    </ng-template>

    <a
      [routerLink]="['/', { outlets: { about: ['about', { identity: 'coevera' }] } }]"
      class="logo">
      <ppl-icon
        width="92px"
        height="30px"
        svgIcon="logo-coevera-white"></ppl-icon>
    </a>
  </div>

  <div class="right">
    <ppl-top-navigation-button
      [pplPopover]="popoverUserMenu"
      pplPopoverAlignEnd>
      @if ((loggedInUser$ | async).profile; as profile) {
        <div class="avatar">
          @if (profile.pictureUrl) {
            <img
              [src]="profile.pictureUrl"
              alt="" />
          } @else {
            <ppl-icon
              svgIcon="my-account-topnavigation"
              width="18px"
              height="18px"></ppl-icon>
          }
        </div>
      } @else {
        <ppl-icon
          svgIcon="my-account-topnavigation"
          width="18px"
          height="18px"></ppl-icon>
      }
    </ppl-top-navigation-button>
    <ng-template
      #popoverUserMenu
      let-position="position">
      <ppl-popover-window [position]="position">
        <ppl-top-navigation-user-menu
          userSettingsRouterLink="/user/edit"
          [userProfile]="(loggedInUser$ | async).profile">
        </ppl-top-navigation-user-menu>
      </ppl-popover-window>
    </ng-template>
  </div>
</div>
